const prefix = 'qbmedia/'

const type = {
    LOAD_LIST_MEDIA: prefix + 'load_list_media',
    LOAD_LIST_MEDIA_SUCCESS: prefix + 'load_list_media_success',
    SET_DEFAULT_CURRENT_MEDIA: prefix + 'set_default_current_media',
    UPDATE_CURRENT_MEDIA: prefix + 'update_current_media',
    SAVE_CURRENT_MEDIA: prefix + 'save_current_media',
    DELETE_MEDIA: prefix + 'delete_media',
    UPDATE_STATE: prefix + 'update_state',
    UPDATE_FILE: prefix + 'update_file',

    CHANGE_PAGE_SIZE: prefix + 'change_page_size',
    CHANGE_CURRENT_PAGE: prefix + 'change_current_page',

    SHOW_MODAL_CURRENT_MEDIA_INFO: prefix + 'show_modal_current_media_info',
    DISMISS_MODAL_CURRENT_MEDIA_INFO:
        prefix + 'dismiss_modal_current_media_info',
    SHOW_MODAL_CONFIRM_DELETE_MEDIA: prefix + 'show_modal_confirm_delete_media',
    DISMISS_MODAL_CONFIRM_DELETE_MEDIA:
        prefix + 'dismiss_modal_confirm_delete_media',

    UPDATE_TEXT_SEARCH: prefix + 'update_text_search',
    SEARCH_MEDIA: prefix + 'search_media',

    GET_LIST_MEDIA_QUERY_BY_ID: prefix + 'get_list_media_query_by_id',
    GET_LIST_MEDIA_QUERY_BY_ID_DONE: prefix + 'get_list_media_query_by_id_done',
    GET_LIST_MEDIA_BY_ID: prefix + 'GET_LIST_MEDIA_BY_ID',
    UPDATE_TEXT_SEARCH_PARAM_SEARCH: prefix + 'UPDATE_TEXT_SEARCH_PARAM_SEARCH'
}

const action = {
    getListMediaById: lst => {
        return {
            type: type.GET_LIST_MEDIA_BY_ID,
            payload: {
                lst,
            },
        }
    },
    getListMediaQueryById: lst => {
        return {
            type: type.GET_LIST_MEDIA_QUERY_BY_ID,
            payload: {
                lst,
            },
        }
    },
    getListMediaQueryByIdDone: data => {
        return {
            type: type.GET_LIST_MEDIA_QUERY_BY_ID_DONE,
            payload: {
                data,
            },
        }
    },
    loadListMedias: params => {
        return {
            type: type.LOAD_LIST_MEDIA,
            payload: {
                params,
            },
        }
    },
    loadListMediasSuccess: medias => {
        return {
            type: type.LOAD_LIST_MEDIA_SUCCESS,
            payload: {
                medias,
            },
        }
    },
    setDefaultCurrentMedia: () => {
        return {
            type: type.SET_DEFAULT_CURRENT_MEDIA,
            payload: {},
        }
    },
    updateCurrentMedia: media => {
        return {
            type: type.UPDATE_CURRENT_MEDIA,
            payload: {
                media,
            },
        }
    },
    saveCurrentMedia: () => {
        return {
            type: type.SAVE_CURRENT_MEDIA,
            payload: {},
        }
    },
    deleteMedia: mediaId => {
        return {
            type: type.DELETE_MEDIA,
            payload: {
                mediaId,
            },
        }
    },
    updateState: state => {
        return {
            type: type.UPDATE_STATE,
            payload: {
                state,
            },
        }
    },
    updateFile: file => {
        return {
            type: type.UPDATE_FILE,
            payload: {
                file,
            },
        }
    },
    changePageSize: pageSize => {
        return {
            type: type.CHANGE_PAGE_SIZE,
            payload: {
                pageSize,
            },
        }
    },
    changeCurrentPage: pageIndex => {
        return {
            type: type.CHANGE_CURRENT_PAGE,
            payload: {
                pageIndex,
            },
        }
    },
    showModalCurrentMediaInfo: () => {
        return {
            type: type.SHOW_MODAL_CURRENT_MEDIA_INFO,
            payload: {},
        }
    },
    dismissModalCurrentMediaInfo: () => {
        return {
            type: type.DISMISS_MODAL_CURRENT_MEDIA_INFO,
            payload: {},
        }
    },
    showModalConfirmDeleteMedia: () => {
        return {
            type: type.SHOW_MODAL_CONFIRM_DELETE_MEDIA,
            payload: {},
        }
    },
    dismissModalConfirmDeleteMedia: () => {
        return {
            type: type.DISMISS_MODAL_CONFIRM_DELETE_MEDIA,
            payload: {},
        }
    },
    updateTextSearch: textSearch => {
        return {
            type: type.UPDATE_TEXT_SEARCH,
            payload: {
                textSearch,
            },
        }
    },
    searchMedia: (begin_time, end_time, type_search) => {
        return {
            type: type.SEARCH_MEDIA,
            payload: { begin_time, end_time, type_search },
        }
    },
    updateParamSearch: (begin_time, end_time, type_search) => {
        return {
            type: type.UPDATE_TEXT_SEARCH_PARAM_SEARCH,
            payload: {
                begin_time, end_time, type_search,
            },
        }
    },
}

export default {
    type,
    action,
}
